const FALLBACK_IMAGES = {
    cat: 'https://tierkrankenversicherungen.check24-test.de/assets/images/cat/default.png',
    dog: 'https://tierkrankenversicherungen.check24-test.de/assets/images/dog/default.svg',
};

export class LastSearchItem {

    constructor(apiItemData, isMobile) {
        this.data = apiItemData || {};
        const result = this.data?.result || {};
        const cta = result.cta || {};
        const inputs = result.inputs || {};
        const tariff = result.tariff || {};

        this.isMobile = isMobile;
        this.filter = 'lastSearches';
        this.time = this.data?.time || 0;
        this.updated = this.data?.updated || 0;
        this.deviceoutput = this.data?.deviceoutput || 'desktop';

        this.animalType = inputs?.animal_type || 'dog';
        this.image = inputs['animal[1][breed_1_image]']
            || FALLBACK_IMAGES[this.animalType]
            || FALLBACK_IMAGES.dog;

        this.fallbackImage = FALLBACK_IMAGES[this.animalType] || FALLBACK_IMAGES.dog;

        this.breed = inputs?.animal_breed_name_1st || '';
        if (inputs?.animal_name === 'null') {
            inputs.animal_name = null;
        }
        this.animalName = inputs?.animal_name || '';
        this.animalAgeWeeks = parseInt(inputs?.animal_age_in_weeks, 10) || 0;
        this.protection = inputs.protection || 'OP-Schutz';

        this.count = tariff?.count || 0;
        this.price = tariff?.best?.price || 0;
        this.period = tariff?.best?.period || 'month';

        this.ctaText = cta?.text || 'Ergebnis anzeigen';
        this.ctaUrl = isMobile ? cta?.url_mobile : cta?.url_desktop;
        this.deleteUrl = result?.url_delete || null;
        this.categoryType = this.data?.type || 'lastSearches';
    }

    get protectionLabel() {
        const map = {
            full: 'Vollschutz',
            op: 'OP-Schutz',
        };

        return map[this.protection] || map.op;
    }

    get protectionIcon() {
        if (this.protection === 'full') {
            return 'full-protection-icon';
        }

        return 'op-protection-icon';
    }

    get periodLabel() {
        if (this.isMobile) {
            const periodMap = {
                'monthly':   'mtl.',
                'month':     'mtl.',
                'quarterly': 'viertelj.',
                'quarter':   'viertelj.',
                'semester':  'halbj.',
                'yearly':    'jährl.',
                'year':      'jährl.',
                'once':      'einmalig'
            };
            return periodMap[this.period]
        }

        const periodMap = {
            'monthly':   'monatlich',
            'month':     'monatlich',
            'quarterly': 'vierteljährlich',
            'quarter':   'vierteljährlich',
            'semester':  'halbjährlich',
            'yearly':    'jährlich',
            'year':      'jährlich',
            'once':      'einmalig'
        };
        return periodMap[this.period]
    }

    get deviceLabel() {
        const map = {
            desktop: 'auf dem PC',
            mobile: 'auf dem Handy',
            app: 'in der App',
            tabletapp: 'in der App',
            tablet: 'auf dem Tablet',
        };

        return map[this.deviceoutput] || map.desktop;
    }

    get timeAgo() {
        const diffSec = Math.floor(Date.now() / 1000) - this.time;

        if (diffSec < 3600) {
            return 'vor Kurzem';
        }

        if (diffSec < 86400) {
            let diffHours = Math.floor(diffSec / 3600);
            if (diffHours <= 1) {
                return 'vor ' + diffHours + ' Stunde';
            }
            return 'vor ' + diffHours + ' Stunden';
        }

        const diffDays = Math.floor(diffSec / 86400);
        return 'vor ' + diffDays + ' Tagen';
    }

    get formattedPrice() {
        return this.price.toFixed(2).replace('.', ',');
    }

    get displayName() {
        return this.animalName || this.breed || '';
    }

    get ageInWeeksToYears() {
        let ageNumber = parseInt(this.animalAgeWeeks, 10);

        const ageRanges = {
            0: '0 - 8 Wochen',
            8: '8 - 12 Wochen',
            12: '12 Wochen - 1 Jahr'
        };

        if (ageNumber >= 52) {
            let ageInYear = Math.floor(ageNumber / 52);
            return ageInYear + (ageInYear === 1 ? ' Jahr' : ' Jahre');
        }

        return ageRanges[ageNumber] || ageNumber + ' Wochen';
    }
}
